import React, { useState, useEffect, useRef } from "react";

const BlockAlert = ({ onClose, isOpen }) => {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [visible, setVisible] = useState(isOpen);
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleBlock = () => {
    console.log("Blocking with reason: ", reason);
    console.log("Note: ", note);
    // onClose();
  };

  const handleCancel = () => {
    console.log("Cancel button clicked");
    onClose();
  };

  return (
    <>
      {isOpen && <div className="alert-overlay"></div>}
      {isOpen && (
        <div
          className="alert-window"
          ref={modalRef}
          onClick={(e) => e.stopPropagation()}
        >
          <h2>Block Calls</h2>
          <p>You will no longer receive calls from ...</p>
          <label htmlFor="reason">Reason:</label>
          <select id="reason" onChange={(e) => setReason(e.target.value)}>
            <option>Persistent calling</option>
            <option>Persistent messaging</option>
            {/* ... */}
          </select>
          <label htmlFor="note">Leave a Note:</label>
          <textarea
            id="note"
            onChange={(e) => setNote(e.target.value)}
          ></textarea>
          <button onClick={handleBlock}>Block</button>
          <button onClick={handleCancel}>Cancel</button>
        </div>
      )}
    </>
  );
};

export default BlockAlert;
